import { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { BranchInspectionsTableContext } from '../contexts';

export const useBranchInspectionsActionBar = () => {
  const { selection, selectAll, fetch, reset, resetSelection } = useContext(BranchInspectionsTableContext);

  const location = useLocation();
  const history = useHistory();

  const create = useCallback(() => {
    history.push('/@next/branch-inspections/create', { background: location });
  }, [history, location]);

  return { selection, resetSelection, create, selectAll, reset, fetch };
};
